import { render, staticRenderFns } from "./RegisterEmailModal.vue?vue&type=template&id=fd839c02&scoped=true"
import script from "./RegisterEmailModal.vue?vue&type=script&lang=js"
export * from "./RegisterEmailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd839c02",
  null
  
)

export default component.exports